module.exports = __webpack_public_path__ + "static/media/shan.b630cd53.png";